import { collection, DocumentData, onSnapshot, QuerySnapshot, Unsubscribe } from 'firebase/firestore';
import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { Card, CardBody, CardHeader, Form, FormControlProps, Table } from 'react-bootstrap';
import { Medida, Sensor } from '../Interfaces/Interfaces';
import { obtenerMedidas } from '../Promesas/Promesas';

import { db } from "../Firebase/Firebase"
import { EncabezadoTablaSensor } from './EncabezadoTablaSensor';
import { Options } from '../Paginas/Dispositivo';
interface Props{
    sensor:Sensor;
    idDispositivo:string;
    filtroCantidad:string;
}
interface Umbral{
    min:number,
    max:number,
    promedio:number
}
const initalUmbrales:Umbral[] = [{max:0,min:0,promedio:0},{max:0,min:0,promedio:0},{max:0,min:0,promedio:0}] 
const TablaSensorRangos = (props:Props) => {
    const [medidas,setMedidas] = useState<Medida[]>([]);
    const [medidasAnt,setMedidasAnt] = useState<Medida[]>([]);
    const [query,setQuery] = useState<QuerySnapshot<DocumentData, DocumentData>>();

    const [umbrales,setUmbrales] = useState<Umbral[]>(initalUmbrales)


    useEffect(()=>{
        



        const medidasRef = collection(db,"dispositivos",props.idDispositivo,"sensores",props.sensor.id,"medidas");
        const unsubscribe = onSnapshot(medidasRef, (querySnapshot) => {
            setQuery(querySnapshot);
    })
    return(()=>{
        unsubscribe();
    })

    },[])
    useEffect(()=>{
        var listado:Medida[] = []
        query?.forEach((doc)=>{
            var medida:Medida = {
                id:doc.data().id,
                valor:doc.data().valor,
                fecha:doc.data().fecha
            }
            listado.push(medida);
        })
        listado.sort((a:Medida,b:Medida)=>{
            if(a.fecha>b.fecha){
                return -1;
            }else if(a.fecha<b.fecha){
                return 1;
            }else{
                return 0;
            }
        })
        
        //Aplicando filtro de cantidad
        console.log(props.filtroCantidad);
        if(parseInt(props.filtroCantidad)>0){
            var list = listado.slice(0,parseInt(props.filtroCantidad));
        }else if(parseInt(props.filtroCantidad)<0){
            var list = listado.slice(0,30);
        }else{
            var list = listado;
        }

        setMedidas(list);
        setMedidasAnt(list);
    },[query])
    useEffect(()=>{
        if(parseInt(props.filtroCantidad)>0){
            var list = medidasAnt.slice(0,parseInt(props.filtroCantidad));
        }else if(parseInt(props.filtroCantidad)<0){
            var list = medidasAnt.slice(0,30);
        }else{
            var list = medidasAnt;
        }
        setMedidas(list);
    },[props.filtroCantidad])


    const setMin = (value:string,index:number,e:any)=>{
        let val;
        if(value.trim().length==0){
            val = 0
            e.currentTarget.value = 0
        }
        else{
            if(value[0]=='0'){
                val = value.substring(1)
                console.log(val)
                val = parseInt(val)
            }else{
                val = parseInt(value)
        
            }
            
        }
        //const val = parseInt(value)
        
        //console.log(val)
        const u1:Umbral = {
            ...umbrales[index],
            min:val,
            promedio:(umbrales[index].max+val)/2
        }
        const listado:Umbral[] = umbrales.map((u,i)=>{
            if(i==index){
                return u1
            }
            else{
                return u
            }
        })
        
        setUmbrales(listado)
        
    }
    const setMax = (value:string,index:number,e:any)=>{
        let val;
        if(value.trim().length==0){
            val = 0
            e.currentTarget.value = 0
        }else{
            if(value[0]=='0'){
                val = value.substring(1)
                console.log(val)
                val = parseInt(val)
            }else{
                val = parseInt(value)
        
            }
            
        }
        
        //const val = parseInt(value)
        console.log(val)
        const u1:Umbral = {
            ...umbrales[index],
            max:val,
            promedio:(umbrales[index].min+val)/2
        }
        const listado:Umbral[] = umbrales.map((u,i)=>{
            if(i==index){
                return u1
            }
            else{
                return u
            }
        })
        
        setUmbrales(listado)
    }
  return (
    <div>
        <Card>
        <CardHeader style={{fontSize:'24px',textAlign:'center'}}>{props.sensor.tipo.charAt(0).toUpperCase() + props.sensor.tipo.slice(1)}</CardHeader>
        <CardBody>
            
        <Table>
            <tr style={{textAlign:'center'}}>
                <th>Medida</th>
                <th>Min</th>
                <th>Max</th>
                <th>Prom</th>
            </tr>
            {
            props.sensor.tipo == "temperatura" && 
            <tr>
                <td>C</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            }
            {
            props.sensor.tipo == "presion" && 
            <tr>
                <td>Hpa</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            }
            {
            props.sensor.tipo == "altitud" && 
            <tr>
                <td>MSNM</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            }
            {
            props.sensor.tipo == "gps" && 
            <>
                <tr>
                <td>Lat</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            <tr>
                <td>Lon</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="number" value={umbrales[1]!.promedio} /></td>
                    
                
            </tr>
            </>
            
            }
            {
            props.sensor.tipo == "acelerometro" && 
            <>
                <tr>
                <td>X</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="number" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            <tr>
                <td>Y</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="number" value={umbrales[1]!.promedio} /></td>
                    
                
            </tr>
            <tr>
                <td>Z</td>
                <td><Form.Control type="number"  onBlur={(e)=>setMin(e.currentTarget.value,2,e)} /></td>
                <td><Form.Control type="number"  onBlur={(e)=>setMax(e.currentTarget.value,2,e)} /></td>
                <td><Form.Control type="number" value={umbrales[2]!.promedio} /></td>
                    
                
            </tr>
            </>
            
            }
{
            props.sensor.tipo == "giroscopio" && 
            <>
                <tr>
                <td>X</td>
                <td><Form.Control type="text"  onBlur={(e)=>setMin(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="text"  onBlur={(e)=>setMax(e.currentTarget.value,0,e)} /></td>
                <td><Form.Control type="text" value={umbrales[0]!.promedio} /></td>
                    
                
            </tr>
            <tr>
                <td>Y</td>
                <td><Form.Control type="text"  onBlur={(e)=>setMin(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="text"  onBlur={(e)=>setMax(e.currentTarget.value,1,e)} /></td>
                <td><Form.Control type="text" value={umbrales[1]!.promedio} /></td>
                    
                
            </tr>
            <tr>
                <td>Z</td>
                <td><Form.Control type="text"  onBlur={(e)=>setMin(e.currentTarget.value,2,e)} /></td>
                <td><Form.Control type="text"  onBlur={(e)=>setMax(e.currentTarget.value,2,e)} /></td>
                <td><Form.Control type="text" value={umbrales[2]!.promedio} /></td>
                    
                
            </tr>
            </>
            
            }


        </Table>

        
        <Table>
            <thead>
                {/* <tr><th colSpan={2}>{props.sensor.tipo}</th></tr> */}
                <tr><th>Fecha</th><th>Hora</th><EncabezadoTablaSensor sensor={props.sensor}/></tr>
            </thead>
            <tbody>        
        {medidas.map((m,index)=>{
            let fechaCompleta = m.fecha.toDate();
            let fecha = fechaCompleta.getDate()+"/"+(fechaCompleta.getMonth()+1)+"/"+fechaCompleta.getFullYear();
            let hora = fechaCompleta.getHours()+":"+fechaCompleta.getMinutes()+":"+fechaCompleta.getSeconds();
            if(props.sensor.tipo==="acelerometro"||props.sensor.tipo==="giroscopio"){
                if(typeof(m.valor)==='object'){
                    return(
                        <tr key={index}>
                            <td >{fecha}</td>
                            <td >{hora}</td>
                        
                             {typeof(m.valor[0])=='number' && (m.valor[0]>umbrales[0].max || m.valor[0]<umbrales[0].min) &&
                        <>
                         
                        <td style={{color:'red'}}>{m.valor[0]}</td>
                        </>}
                        {typeof(m.valor[0])=='number' && (m.valor[0]>=umbrales[0].min && m.valor[0]<=umbrales[0].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor[0]}</td>
                        </>}
                        {/* index1 */}
                        {typeof(m.valor[1])=='number' && (m.valor[1]>umbrales[1].max || m.valor[1]<umbrales[1].min) &&
                        <>
                        <td style={{color:'red'}}>{m.valor[1]}</td>
                        </>}
                        {typeof(m.valor[1])=='number' && (m.valor[1]>=umbrales[1].min && m.valor[1]<=umbrales[1].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor[1]}</td>
                        </>}
                        {/* index2 */}
                        {typeof(m.valor[2])=='number' && (m.valor[2]>umbrales[2].max || m.valor[2]<umbrales[2].min) &&
                        <>
                         
                        <td style={{color:'red'}}>{m.valor[2]}</td>
                        </>}
                        {typeof(m.valor[2])=='number' && (m.valor[2]>=umbrales[2].min && m.valor[2]<=umbrales[2].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor[2]}</td>
                        </>}
                        </tr>
                        
                )
                }
                
            }else if(props.sensor.tipo==="gps"){
                if(typeof(m.valor)==='object'){
                    return(
                        <tr key={index}>
                            <td >{fecha}</td>
                            <td >{hora}</td>
                        
                            {typeof(m.valor[0])=='number' && (m.valor[0]>umbrales[0].max || m.valor[0]<umbrales[0].min) &&
                        <>
                         
                        <td style={{color:'red'}}>{m.valor[0]}</td>
                        </>}
                        {typeof(m.valor[0])=='number' && (m.valor[0]>=umbrales[0].min && m.valor[0]<=umbrales[0].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor[0]}</td>
                        </>}
                        {/* index1 */}
                        {typeof(m.valor[1])=='number' && (m.valor[1]>umbrales[1].max || m.valor[1]<umbrales[1].min) &&
                        <>
                         
                        <td style={{color:'red'}}>{m.valor[1]}</td>
                        </>}
                        {typeof(m.valor[1])=='number' && (m.valor[1]>=umbrales[1].min && m.valor[1]<=umbrales[1].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor[1]}</td>
                        </>}
                        </tr>
                        
                )
                }
            }
            else{
                
                
                return(
                    <tr key={index}>
                        <td >{fecha}</td>
                        <td >{hora}</td>
                        
                        {typeof(m.valor)=='number' && (m.valor>umbrales[0].max || m.valor<umbrales[0].min) &&
                        <>
                         
                        <td style={{color:'red'}}>{m.valor}</td>
                        </>}
                        {typeof(m.valor)=='number' && (m.valor>=umbrales[0].min && m.valor<=umbrales[0].max) &&
                        <>
                         
                        <td style={{color:'green'}}>{m.valor}</td>
                        </>}
                    </tr>
                    
            )
            }
            
            
            
        })}
            </tbody>
        </Table>
        </CardBody>
        </Card>


        
    </div>
  )
}

export default TablaSensorRangos
